import { getEnvironment } from '@experiences/util';
import type { User } from '@uipath/auth-react';
import Cookies from 'js-cookie';

export default function setSignInCookie(user: User, loginMethod: string) {
    const env = getEnvironment();

    Cookies.set(`lastUsedLoginEmail-${env}`, user.profile.email ?? 'unknown', {
        domain: env === 'local' ? 'localhost' : '.uipath.com',
        expires: 60,
    });

    // On success, promote the currentLoginMethod cookie to lastUsedLoginMethod
    Cookies.set(`currentLoginMethod-${env}`, loginMethod, {
        domain: env === 'local' ? 'localhost' : '.uipath.com',
        expires: 60,
    });
    Cookies.set(`lastUsedLoginMethod-${env}`, loginMethod, {
        domain: env === 'local' ? 'localhost' : '.uipath.com',
        expires: 60,
    });
}
